import React, { Component } from 'react';

export class ChartShowAll extends Component {

    render() {
        return <span className="chartshowall" onClick={this.props.onShowAll}>{this.props.showAll ? "less..." : "more..."}</span>
    }
}
